import React from "react"

import JobDetail from "../../features/jobFinder/views/jobDetail"

const Details = () => <JobDetail />

export default Details
